<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-calendar-o"></span>{{ 'bikeshop.menu.reservation_calendar' | translate
      }}</div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>

  <div class="calendar-container">
    <div class="content">
      <div class="filter" *ngIf="showFilter">
        <div class="search-icon">
          <div [ngClass]="{'hubtiger-search': !enableSearch, 'hubtiger-close': enableSearch}" (click)="clearSearch()">
          </div>
        </div>
        <div *ngIf="enableSearch" class="search-type-container">
          <p-radioButton name="searchOption" value="JOBCARD" label="{{ 'general.headers.job_card' | translate }}"
            [(ngModel)]="selectedSearchOption" (click)="clearSearchData()"></p-radioButton>
          <p-radioButton name="searchOption" value="PRODUCTS"
            label="{{ 'bikeshop.rentals.booking.products' | translate }}" [(ngModel)]="selectedSearchOption"
            (click)="clearSearchData()"></p-radioButton>
        </div>
        <div *ngIf="enableSearch" style="margin-left: -8px;margin-right: -8px;">
          <div class="margin-top-16 margin-bottom-16">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon" (click)="search()"><i class="fa fa-search"></i></span>
              <input #searchtextbox type="text" [(ngModel)]="searchRequest" pInputText
                placeholder="{{ 'general.search' | translate}}" (keydown.enter)="search()">
            </div>
            <div class="search-info" *ngIf="selectedSearchOption === 'JOBCARD'">{{
              'bikeshop.rentals.booking.search_info_job_cards' | translate }}</div>
            <div class="search-info" *ngIf="selectedSearchOption === 'PRODUCTS'">{{
              'bikeshop.rentals.booking.search_info_rentals' | translate }}</div>
          </div>
        </div>
        <div *ngIf="enableSearch && searching" style="margin-top: 32px;display: flex;justify-content: center;">
          <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
          </p-progressSpinner>
        </div>
        <div *ngIf="enableSearch && selectedSearchOption === 'JOBCARD' && searchResults && searchResults.length > 0"
          style="position: relative;height: calc(100% - 100px);overflow: auto;margin-left: -8px;margin-right: -8px;">
          <div class="search-results-container">
            <div *ngFor="let result of searchResults" class="search-result" (click)="openSearchResult(result)">
              <div><span class="fa fa-user"></span>{{result.customer}}</div>
              <div><span class="fa fa-hashtag"></span>{{result.reservationNumber}}</div>
              <div><span class="fa fa-arrow-right"></span>{{result.fromDate | date : 'h:mma, d MMM yyyy'}}
              </div>
              <div><span class="fa fa-arrow-left"></span>{{result.toDate | date : 'h:mma, d MMM yyyy'}}
              </div>
              <div><span class="fa fa-circle-o-notch"></span>{{result.reservationStatus}}</div>
              <div *ngFor="let product of result.reservedProducts">
                <span class="fa fa-shopping-basket"></span>{{product.brand}} {{product.model}}
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!enableSearch">


          <div class="category">
            <div>
              <p-checkbox name="ProductImages" [(ngModel)]="hideProductImages" [binary]="true"
              pTooltip="{{'bikeshop.rentals.booking.hide_product_detail' | translate}}"
                (click)="actionProductImages()"></p-checkbox>
            </div>
            <div>
              {{'bikeshop.rentals.booking.hide_product_detail' | translate}}
            </div>
          </div>
        
            

          <p-fieldset legend="{{'bikeshop.statuses.to_deliver' | translate}}"
            *ngIf="rentalStoreRules.enableDeliveries || rentalStoreRules.enableCollections">
            <div class="category">
              <div>
                <p-checkbox name="Deliveries" [(ngModel)]="showDeliveries" [binary]="true"
                pTooltip="{{'bikeshop.rentals.booking.show_delivery_reservations' | translate}}"
                  (click)="showNonDeliveries=false;filterCalendarProducts()"></p-checkbox>
              </div>
              <div>
                {{'bikeshop.rentals.booking.show_delivery_reservations' | translate}}
              </div>
            </div>

            <div class="category">
              <div>
                <p-checkbox name="Deliveries" [(ngModel)]="showNonDeliveries" [binary]="true"
                pTooltip="{{'bikeshop.rentals.booking.show_non_delivery_reservations' | translate}}"
                  (click)="showDeliveries=false;filterCalendarProducts()"></p-checkbox>
              </div>
              <div>
                {{'bikeshop.rentals.booking.show_non_delivery_reservations' | translate}}
              </div>
            </div>
          </p-fieldset>


          <p-fieldset legend="{{'bikeshop.shop_setup.card_headers.rental_affiliates' | translate}}"
            *ngIf="affiliates.length > 0">

            <!-- <p-multiSelect 
            [options]="affiliates" 
            [(ngModel)]="selectedAffiliates" 
            optionLabel="affiliateName" 
            display="chip"
            [filter]="false" 
            (click)="filterCalendarProducts()"
            placeholder="{{'bikeshop.shop_setup.card_headers.rental_affiliates' | translate}}" /> -->

            <div *ngFor="let affiliate of affiliates" class="category">
              <div>
                <p-checkbox name="Affiliates" [value]="affiliate" [(ngModel)]="selectedAffiliates"
                  pTooltip="{{'bikeshop.rentals.booking.show_affiliate_reservations' | translate}}"
                  (click)="filterCalendarProducts()"                  
                  ></p-checkbox>
              </div>
              <div>
                {{affiliate.affiliateName}}
              </div>
            </div>
          </p-fieldset>

          <p-fieldset legend="{{'bikeshop.general.categories' | translate}}" *ngIf="categories.length > 0">
            <div *ngFor="let category of categories" class="category">
              <div>
                <p-checkbox name="Categories" [value]="category" [(ngModel)]="selectedCategories"
                  (click)="filterCalendarProducts()"></p-checkbox>
              </div>
              <div>
                {{category}}
              </div>
            </div>
          </p-fieldset>

          <p-fieldset legend="{{'bikeshop.products.brand' | translate}}" *ngIf="brands.length > 0">
            <div *ngFor="let brand of brands" class="category">
              <div>
                <p-checkbox name="Brands" [value]="brand" [(ngModel)]="selectedBrands"
                  (click)="filterCalendarProducts()"></p-checkbox>
              </div>
              <div>
                {{brand}}
              </div>
            </div>
          </p-fieldset>

          <p-fieldset legend="{{'bikeshop.rentals.products.sizes' | translate }}" *ngIf="sizes.length > 0">
            <div *ngFor="let size of sizes" class="category">
              <div>
                <p-checkbox name="Sizes" [value]="size" [(ngModel)]="selectedSizes" (click)="filterCalendarProducts()">
                </p-checkbox>
              </div>
              <div>
                {{size}}
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
      <div class="calendar" [ngClass]="{'hide-calendar': !rentalsConfigured}">

        <full-calendar #calendar schedulerLicenseKey="0984855613-fcs-1539348025" ignoreTimezone="false"
          [nowIndicator]="true" [now]="getNowDate()" timeZone="UTC" defaultView="Day"
          [locales]="[ 'enLocale', 'esLocale' ]"                        
          [header]="{
              right: 'prev, next, today',
              center: 'title',
              left: headerView
          }"
          [views]="calendarViews" [contentHeight]="contentHeight" [plugins]="calendarPlugins"
          [buttonText]="calendarButtonText"
          [weekends]="calendarWeekends" [resources]="rentalProducts" resourceOrder="sortIndex" [minTime]="minTime"
          [maxTime]="maxTime" [allDaySlot]="false" [selectable]="true" [editable]="false"
          (eventRender)="renderEvent($event)" (select)="dateRangeSelected($event)"
          (resourceRender)="renderResource($event)" (eventClick)="reservationClicked($event)" [firstDay]="1"
          resourceLabelText="{{ 'bikeshop.rentals.products.resource_name' | translate }}"
          (datesRender)="datesRender($event)">
        </full-calendar>
      </div>
      <div *ngIf="!rentalsConfigured && !loadingConfig" class="not-configured">
        <div><span class="fa fa-calendar-o"></span></div>
        <div>{{ 'bikeshop.rentals.booking.not_configured' | translate }}</div>
      </div>
    </div>
  </div>
</div>

<!--todo (dcorbett) no rentalAccessories  [fullAccessoryList]="rentalAccessories"-->
<p-sidebar #BookRentalReservation [(visible)]="showBookRentalReservation" position="right" [showCloseIcon]="false"
  [autoZIndex]="false" [baseZIndex]="0" (onHide)="BookRentalReservation.destroyModal();"
  [style]="{width:'950px', background: '#FAFAFA', 'overflow-x': 'auto','z-index': '1001'}">
  <div *ngIf="showBookRentalReservation">
    <app-book-rental-reservation [bookingInfo]="bookingInfo" (close)="refreshCalendar()" [categories]="categories"
      [brands]="brands" [sizes]="sizes" [rentalStoreRules]="rentalStoreRules"></app-book-rental-reservation>
  </div>
</p-sidebar>

<p-sidebar #RentalReservationUpdate [(visible)]="showRentalReservation" position="right" [autoZIndex]="false"
  [showCloseIcon]="false" [baseZIndex]="0"
  [style]="{width:'950px', background: '#FAFAFA', 'overflow-x': 'auto','z-index': '1001'}"
  (onHide)="RentalReservationUpdate.destroyModal();refreshCalendar()">
  <div *ngIf="showRentalReservation">
    <app-rental-reservation-update [reservationSummary]="selectedReservation" [categories]="categories"
      [brands]="brands" [sizes]="sizes" [rentalStoreRules]="rentalStoreRules"></app-rental-reservation-update>
  </div>
</p-sidebar>

<p-sidebar #AddEditRentalProduct [(visible)]="showRentalProduct" position="right" [autoZIndex]="false" [baseZIndex]="0"
  [showCloseIcon]="false" [style]="{width:'700px', background: '#F6F6F8', 'overflow-x': 'auto','z-index': '1001'}"
  (onHide)="AddEditRentalProduct.destroyModal();getRentalProducts()">
  <div *ngIf="showRentalProduct">
    <app-add-edit-rental-product [product]="selectedProduct" [cloneProduct]="false" [messageService]="messageService"
      (close)="closeRentalProduct()"></app-add-edit-rental-product>
  </div>
</p-sidebar>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>